module.exports = __webpack_public_path__ + "img/9788992263146.9dd122fe.jpg";